<template>
    <div class="bg-color-granite pb-10">
		<div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"			
				:height="199"
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="Rewards Paid" /></h1>
			</div>			
		</div>
        <div class="bg-color-granite w-100 h-100">
            <div class="bg-color-quartz w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 bg-color-dell-blue tx-color-white">
                    <v-col cols="10" class="d-flex flex-column justify-start w-100 pa-0 pb-5 tx-font-normal tx-font-size20">  
                        <v-row no-gutters>
                                <div class="body-text text-white mt-4">
                                    <p class="pb-2">
                                        <LanguagePlaceholder default-text="This page shows you all the E-Vouchers and Credit Notes you have earned with RISE across
                                        all the quarters." />
                                    </p>
                                    <p class="pb-2">
                                        <LanguagePlaceholder default-text="You have the option to toggle between E-Vouchers and Credit Notes to obtain your reward
                                        information. For those quarters you have earned more than $850 in rewards, you will see
                                        a Credit Note. For those other quarters where you have earned $850 or less, you will see
                                        an e-voucher." />

                                    </p>
                                    
                                    <p>
                                        <LanguagePlaceholder is-html default-text="Please <route route-name='contact-us' style='text-decoration: underline;'>Contact Support</route> if you have any queries." />
                                   </p>
                                </div>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </div>
        <div class="bg-color-granite w-100 h-100 my-2 px-10">
            <v-row class="d-flex justify-center w-100 pa-0 ma-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 py-3 tx-font-bold bg-color-quartz">                      
                    <v-tabs v-model="selectedTab">
                        <v-tab :value="0">E-Vouchers</v-tab>
                        <v-tab :value="1">Credit Notes</v-tab>
                    </v-tabs>
                    <v-spacer></v-spacer>
                        <v-toolbar density="compact" class="w-25" color="#EEEEEE">
                            <v-spacer></v-spacer>
                            <v-btn icon="mdi-download" @click="downloadFile"><v-icon size="large">mdi-download</v-icon></v-btn>
                        </v-toolbar>
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
            </v-row>

            <v-row class="d-flex justify-center w-100 pa-0 ma-0 mt-n10">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 py-10 tx-font-bold bg-color-quartz">     

                    <v-window v-model="selectedTab" class="pa-2 w-100">                        
                        <v-window-item :value="0">
                            <div class="bg-color-dell-blue tx-color-white tx-font-normal px-10 pt-5">
                                    <p class="pb-2">
                                        <LanguagePlaceholder
                                            default-text="Please note the two types of e-voucher statuses below." />
                                    </p>
                                    <ul>
                                        <li>
                                            <strong>
                                                <LanguagePlaceholder default-text="Rewards Redeemed:" />
                                            </strong>
                                            <LanguagePlaceholder default-text=" you converted your rewards into an E-voucher. They will show in
                                            this report, the moment you issue/redeem them" />

                                        </li>
                                        <li>
                                            <strong>
                                                <LanguagePlaceholder default-text="Utilized:" />
                                            </strong>
                                            <LanguagePlaceholder default-text=" you used your E-voucher for a new purchase with your chosen Distributor.
                                            Please note: Redeemed E-vouchers must be used before their expiry date." />

                                        </li>
                                    </ul>
                                    <br>
                                    <p>
                                        <LanguagePlaceholder default-text="Please note: An E-voucher can take up to 4 weeks to convert from “Rewards Redeemed” to
                                        “Utilized” status as this depends on how fast your chosen Distributor reports the use of
                                        the e-voucher to us." />

                                    </p>
                                    <br>
                        </div>
                            <v-text-field class="ma-2" v-model="searchEVoucherString" label="Filter"
                                prepend-inner-icon="mdi-filter-outline" variant="outlined" hide-details
                                single-line></v-text-field>
                            <v-data-table items-per-page="50" :headers="headersEvouchers" :items="evoucherData"
                                item-key="id" :search="searchEVoucherString" class="v-data-table-row">
                                <template v-slot:item.amountUSD="{ item }">
                                    {{ $filters.currencyUSD(item.amountUSD) }}
                                </template>
                                <template v-slot:item.amountLocalCurrency="{ item }">
                                    {{ $filters.toGenericCurrency(item.amountLocalCurrency) }}
                                </template>
                                <template v-slot:item.downloadEVoucher="{ item }">
                                    <div class="tx-color-cobalt">
                                        <v-btn size="small" icon="mdi-download" @click="downloadEVoucher(item)"></v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-window-item>
                        <v-window-item :value="1">
                            <div class="bg-color-dell-blue tx-color-white tx-font-normal px-10 pt-5">
                                    <ul>
                                        <li>
                                            <LanguagePlaceholder default-text="This page will show you earned Credit Notes (if you earned more than $850 rewards in a quarter) and the Distributor you earned that Credit Note with." />

                                        </li>
                                        <li>
                                            <LanguagePlaceholder default-text="These rewards are applied directly to your account with the Distributor and should reflect as a credit for your next purchase. You can enquire directly with your Distributor." />

                                        </li>
                                        <li>
                                            <LanguagePlaceholder default-text="Please note that Credit Note information is updated quarterly (approximately 4 – 6 weeks after the quarter has ended)." />

                                        </li>
                                    </ul>
                                    <br>
                            </div>
                            <v-text-field class="ma-2" v-model="searchCreditNoteString" label="Filter"
                                prepend-inner-icon="mdi-filter-outline" variant="outlined" hide-details
                                single-line></v-text-field>
                            <v-data-table items-per-page="50" :headers="headersCreditNotes" :items="creditnoteData"
                                item-key="id" :search="searchCreditNoteString" class="v-data-table-row">
                                <template v-slot:item.amountUSD="{ item }">
                                    {{ $filters.currencyUSD(item.amountUSD) }}
                                </template>
                                <template v-slot:item.amountLocalCurrency="{ item }">
                                    {{ $filters.toGenericCurrency(item.amountLocalCurrency) }}
                                </template>
                                <template v-slot:item.downloadEVoucher="{ item }">
                                    <v-btn size="small" icon="mdi-download" @click="downloadEVoucher(item)"></v-btn>
                                </template>
                            </v-data-table>
                        </v-window-item>
                    </v-window>
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
            </v-row>
        </div>
    </div>

</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useSystemStore } from '@/stores/system'
import { usePartnerStore } from '@/stores/partner'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import { useExcelStore } from '@/stores/excel'


const systemStore = useSystemStore()
const partnerStore = usePartnerStore()
const excelStore = useExcelStore()

const selectedTab = ref(0)
const searchEVoucherString = ref('')
const searchCreditNoteString = ref('')
const evoucherData = ref([])
const creditnoteData = ref([])

const headersEvouchers = [
    { title: 'Download EVoucher Copy', value: 'downloadEVoucher', width:25, sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'quarter', title: 'Quarter', align: 'start', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'eVoucherNumber', title: 'EVoucher No.', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'distributorName', title: 'Distributor', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'amountUSD', title: '$ Amount', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'localCurrency', title: 'Local Currency', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'amountLocalCurrency', title: 'Local Currency Amount', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'status', title: 'Status', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'expiryDate', title: 'ExpiryDate', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },

]

const headersCreditNotes = [
    { key: 'quarter', title: 'Quarter', align: 'start', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'creditNoteNumber', title: 'Credit Note No.', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'datePaymentIssuedString', title: 'Date Payment Issued', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'distributorName', title: 'Distributor', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'amountUSD', title: '$ Amount', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'localCurrency', title: 'Local Currency', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'amountLocalCurrency', title: 'Local Currency Amount', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
    { key: 'comment', title: 'Comment', align: 'end', sortable: false, headerProps: { class: 'v-data-table-header'} },
]

onMounted(() => {
    getEVoucherData()
    getCreditNoteData()
})

const downloadFile = () => {
    if (selectedTab.value == 0) {
        excelStore.generateInMemoryExcelDocument(evoucherData.value, 'PartnerEvoucherStatementDocument').catch(error => {
            console.log('Generate In Memory Excel Document - PartnerEvoucherStatementDocument', error)
        })
    } else if (selectedTab.value == 1) {
        excelStore.generateInMemoryExcelDocument(creditnoteData.value, 'PartnerCreditNoteStatementDocument').catch(error => {
            console.log('Generate In Memory Excel Document - PartnerCreditNoteStatementDocument', error)
        })
    }
}

const getEVoucherData = () => {
    partnerStore.getEVoucherData().then((res) => {
        evoucherData.value = res.responseData
    }).catch(error => {

    })
}

const getCreditNoteData = () => {
    partnerStore.getCreditNoteData().then((res) => {
        creditnoteData.value = res.responseData ?? ref([])
    }).catch(error => {
console.log(error)
    })
}

const downloadEVoucher = (item) => {
    systemStore.downloadPartnerEVoucher(item.eVoucherNumber).then(res => {
        systemStore.openPdfInNewWindow(res.base64Pdf, "EVoucher_" + item.eVoucherNumber + ".pdf")
    }).catch(error => {
        console.log(error)
    })
}

</script>

<style scoped>
</style>